/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @returns {React.ReactElement}
 */
const PlayIcon = ({ className }) => (
  <svg
    className={className}
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="44" height="44" fill="white" fillOpacity="0.9" />
    <path
      d="M28.7687 21.1706C29.3571 21.567 29.3571 22.433 28.7687 22.8294L18.0587 30.0434C17.3944 30.4908 16.5 30.0149 16.5 29.214L16.5 14.786C16.5 13.9851 17.3944 13.5092 18.0587 13.9566L28.7687 21.1706Z"
      fill="#002967"
    />
  </svg>
);

export default PlayIcon;
